"use client";

import { useEffect, useState } from "react";
import { ArrowUpIcon } from "lucide-react";
import { useTranslations } from "next-intl";

export default function BackToTop() {
  const t = useTranslations("site.common");
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      type="button"
      aria-label={t("backToTop")}
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className="fixed bottom-6 right-6 z-50 flex h-11 w-11 items-center justify-center rounded-full bg-foreground/85 text-background shadow-lg backdrop-blur transition hover:bg-foreground"
    >
      <ArrowUpIcon className="h-5 w-5" />
    </button>
  );
}
